import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    {
        path: '404',
        loadChildren: './pages/not-found-404/not-found-404.module#NotFound404PageModule'
    },
    {
        path: 'dashboard',
        loadChildren: './pages/undermaintenance/undermaintenance.module#UnderMaintenancePageModule'
    },
    {
        path: 'report',
        loadChildren: './pages/undermaintenance/undermaintenance.module#UnderMaintenancePageModule'
    },
    {
        path: 'componentwise',
        loadChildren: './pages/dashboard/dashboard.module#DashboardPageModule'
    },
    {
        path: 'transactionhistory',
        loadChildren: './pages/transactionhistory/transactionhistory.module#TransactionHistoryPageModule'
    },
    {
        path: '',
        loadChildren: './pages/login/login.module#LoginPageModule'
    },
    {
        path: 'login',
        loadChildren: './pages/login/login.module#LoginPageModule'
    },
    {
        path: 'vendorregister',
        loadChildren: './pages/vendor-register/vendor-register.module#VendorRegisterPageModule'
    },
    {
        path: 'signup',
        loadChildren: './pages/signup/signup.module#SignupPageModule'
    },
    {
        path: 'addusers',
        loadChildren: './pages/addusers/addusers.module#AddusersPageModule'
    },
    // {
    //     path: 'addDeduction',
    //     loadChildren: './pages/add_deduction/add_deduction.module#AddDeductionPageModule'
    // },
    // {
    //     path: 'deductionhistory',
    //     loadChildren: './pages/deductionhistory/deductionhistory.module#DeductionHistoryPageModule'
    // },
    {
        path: 'officecreation',
        loadChildren: './pages/officecreate/officecreate.module#OfficeCreatePageModule'
    },
    {
        path: 'manageoffices',
        loadChildren: './pages/manageoffices/manageoffices.module#ManageOfficesPageModule'
    },
    {
        path: 'deactivatedoffices',
        loadChildren: './pages/deactivatedoffices/deactivatedoffices.module#DeactivatedOfficesPageModule'
    },
    {
        path: 'myprofile',
        loadChildren: './pages/myprofile/myprofile.module#MyProfilePageModule'
    },
    {
        path: 'bulkupload',
        loadChildren: './pages/bulkupload/bulkupload.module#BulkUploadPageModule'
    },
    {
        path: 'manage-users',
        loadChildren: './pages/manageusers/manageusers.module#ManageUsersPageModule'
    },
    {
        path: 'manage-dsc',
        loadChildren: './pages/manage_dsc/manage_dsc.module#ManageDscPageModule'
    },
    {
        path: 'deactivateusers',
        loadChildren: './pages/deactivateusers/deactivateusers.module#DeactivateUsersPagePageModule'
    },
    {
        path: 'allocateexpenditure',
        loadChildren: './pages/allocate-expenditure/allocate-expenditure.module#AllocateExpenditurePageModule'
    },
    {
        path: 'dscregistration',
        loadChildren: './pages/dscregistration/dscregistration.module#DscRegistrationPageModule'
    },
    {
        path: 'vendorpaymentcreation',
        loadChildren: './pages/vendorpaymentcreation/vendorpaymentcreation.module#VendorPaymentCreationPageModule'
    },
    {
        path: 'list/:type',
        loadChildren: './pages/list/list.module#ListPageModule'
    },
    {
        path: 'logout',
        loadChildren: './pages/logout/logout.module#LogoutPageModule'
    },
    {
        path: 'vendorslist',
        loadChildren: './pages/vendorslist/vendorslist.module#VendorsListPageModule'
    },
    {
        path: 'approvevendor/:requestID',
        loadChildren: './pages/approvevendor/approvevendor.module#ApproveVendorPageModule'
    },
    {
        path: 'approvepayment/:requestID',
        loadChildren: './pages/approvepayment/approvepayment.module#ApprovePaymentPageModule'
    },
    {
        path: 'editvendor/:requestID',
        loadChildren: './pages/editvendor/editvendor.module#EditVendorPageModule'
    },
    {
        path: 'approvalpendingvendorslist',
        loadChildren: './pages/approvalpendingvendorslist/approvalpendingvendorslist.module#ApprovalPendingVendorsListPageModule'
    },
    {
        path: 'approvalpendingpaymentlist',
        loadChildren: './pages/approvalpendingpaymentlist/approvalpendingpaymentlist.module#ApprovalPendingPaymentListPageModule'
    },
    {
        path: 'approvalpendingallote',
        loadChildren: './pages/approvalpendingallote/approvalpendingallote.module#ApprovalPendingAllotePageModule'
    },
    {
        path: 'approvedvendorslist',
        loadChildren: './pages/approvedvendorslist/approvedvendorslist.module#ApprovedVendorsListPageModule'
    },
    {
        path: 'approvedallotlist',
        loadChildren: './pages/approvedallotlist/approvedallotlist.module#ApprovedAllotListPageModule'
    },
    {
        path: 'approvedpaymentlist',
        loadChildren: './pages/approvedpaymentlist/approvedpaymentlist.module#ApprovedPaymentListPageModule'
    },
    {
        path: 'home/:type',
        loadChildren: './pages/home/home.module#HomePageModule'
    },
    {
        path: 'about',
        loadChildren: './pages/about/about.module#AboutPageModule'
    }
    ,
    {
        path: 'changepassword',
        loadChildren: './pages/change-password/change-password.module#ChangePasswordPageModule'
    },
    {
        path: 'authorization-required',
        loadChildren: './pages/unauthorized/unauthorized.module#UnauthorizedModule'
    }

];

@NgModule({
    //imports: [RouterModule.forRoot(routes)],
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
